export { PortalCardClient } from './smart-card-client';
